import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import EditCommissionListing from '@/modules/promotion/components/EditCommission/components/EditCommissionListing'

function EditCommissionPage() {
	return (
		<PageContainer>
			<EditCommissionListing />
		</PageContainer>
	)
}

const GuardedEditCommissionPage = withUserPermission(EditCommissionPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_COMMISSION_CASHBACK],
})

export default GuardedEditCommissionPage
